module.exports = __webpack_public_path__ + "static/media/ico_simulation_face_forehead.ee1d84b1.png";